import React, { createContext, useContext, useMemo } from 'react';

const OverlayContext = createContext(null);

export const useOverlay = () => {
  return useContext(OverlayContext);
};

export const OverlayProvider = ({ children, showOverlay, hideOverlay }) => {
  const value = useMemo(() => ({ showOverlay, hideOverlay }), [showOverlay, hideOverlay]);
  return (
    <OverlayContext.Provider value={value}>
      {children}
    </OverlayContext.Provider>
  );
};


